import React from 'react';
import styled from 'styled-components';

import type { IPopularDestinationsOfferDefault } from 'src/routes/Home/store/popularDestinationsOffers/types';

import CountryContentWrapper from '../../../../CountryContentWrapper';
import CountryBackgroundImage from '../../../../CountryBackgroundImage';
import Card from '../../../../Card';
import CardHeading from '../../../../CardHeading';
import CardButton from '../../../../CardButton';

import { RELINKING_VARIANTS } from '../../../../../constants';

interface IPopularCountry extends IPopularDestinationsOfferDefault {
  isFirst?: boolean;
  isMobile: boolean;
}

export const PopularCountry = (props: IPopularCountry) => {
  const { place, link, imageUrl, regions, isFirst = false, isMobile } = props;

  return (
    <StyledCountryContaner
      $isFirst={isFirst}
      $isMobile={isMobile}
      $variant={RELINKING_VARIANTS.DEFAULT_COUNTRIES}
    >
      <StyledLink href={`${link}?ref_content=main_page`}>
        <CountryBackgroundImage src={imageUrl} />
        <CountryContentWrapper>
          <CardHeading
            text={place}
            url={link}
            isMobile={isMobile}
            hasMarginTop
          />
          <StyledCitiesContainer>
            {regions.map((region) => (
              <CardButton
                text={region.place}
                url={region.link}
                isMobile={isMobile}
                key={`${place}_region_${region.place}`}
              />
            ))}
          </StyledCitiesContainer>
        </CountryContentWrapper>
      </StyledLink>
    </StyledCountryContaner>
  );
};

const StyledLink = styled.a`
  display: block;
  height: 100%;
`;

const StyledCountryContaner = styled(Card)<{
  $isFirst: boolean;
  $isMobile: boolean;
}>`
  width: ${({ $isFirst, $isMobile }) => ($isFirst && !$isMobile ? 320 : 240)}px;
`;

const StyledCitiesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
